import React from 'react';

export enum RouteEnum {
  ADMINISTRATION = '/administration',
  CALENDAR = '/calendar',
  CARS = '/cars',
  CARS_DETAILS = '/cars/:carId',
  CATALOG = '/catalog',
  CHATS = '/chats',
  CONTACTS = '/contacts',
  CONTACTS_CREATE = '/contacts/create',
  CONTACTS_DETAILS = '/contacts/:contactId',
  CONTACTS_EDIT = '/contacts/:contactId/edit',
  CUSTOMERS = '/customers',
  CUSTOMERS_CREATE_BUSINESS = '/customers/create-business',
  CUSTOMERS_CREATE_FOREIGN = '/customers/create-foreign',
  CUSTOMERS_CREATE_INDIVIDUAL = '/customers/create-individual',
  CUSTOMERS_DETAILS = '/customers/:customerId',
  CUSTOMERS_EDIT = '/customers/:customerId/edit',
  DASHBOARD = '/dashboard',
  DICTIONARIES = '/dictionaries',
  DISHES = '/dishes',
  DISHES_DETAILS = '/dishes/:dishId',
  DISHES_IMPORT = '/dishes/import',
  EMAILS = '/emails',
  EMERGENCY_CONTACTS = '/emergency-contacts',
  EMERGENCY_CONTACTS_CREATE = '/emergency-contacts/create',
  EMERGENCY_CONTACTS_DETAILS = '/emergency-contacts/:emergencyContactId',
  EMERGENCY_CONTACTS_EDIT = '/emergency-contacts/:emergencyContactId/edit',
  FORBIDDEN = '/forbidden',
  HR = '/hr',
  LOGIN_SUCCESSFUL = '/login-successful',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '/not-found',
  OFFER_ELEMENT_DETAILS = '/offer-elements/:offerElementId',
  OFFER_ELEMENTS = '/offer-elements',
  OFFER_GROUP_DEFINITION_DETAILS = '/offer-group-definitions/:offerGroupDefinitionId',
  OFFER_GROUP_DEFINITIONS = '/offer-group-definitions',
  OFFERS = '/offers',
  OFFERS_CREATE_PREDEFINED = '/offers/create-predefined',
  PPTX_IMPORT_DETAILS = '/dishes/import/pptx/:draftId',
  PPTX_IMPORTS = '/dishes/import/pptx',
  PROCESSES = '/processes',
  PROCESSES_CREATE = '/processes/create',
  PROCESSES_DETAILS = '/processes/:processId',
  PROCESSES_DETAILS_MULTI_OFFER = '/processes/:processId/multi/:multiOfferId',
  PROCESSES_DETAILS_MULTI_OFFER_CREATE = '/processes/:processId/multi/create',
  PROCESSES_DETAILS_OFFER = '/processes/:processId/multi/:multiOfferId/offers/:offerId',
  PROCESSES_DETAILS_OFFER_CREATE = '/processes/:processId/multi/:multiOfferId/offers/create',
  PROCESSES_DETAILS_OFFERS = '/processes/:processId/offers',
  REPORTS = '/reports',
  ROOT = '/',
  SETTLEMENTS = '/settlements',
  STATISTICS = '/statistics',
  SUPPLIERS = '/suppliers',
  SUPPLIERS_DETAILS = '/suppliers/:supplierId',
  TASK_DETAILS = '/tasks/:taskId',
  TASKS = '/tasks',
  USERS = '/users',
  WAITING_FOR_APPROVAL = '/waiting-for-approval',
}

export interface RouteChildModel {
  component: React.ComponentType;
  index?: boolean;
  path?: string;
}

export interface RouteModel {
  children?: RouteChildModel[];
  component?: React.ComponentType;
  load?: () => Promise<{ default: React.ComponentType }>;
  path: RouteEnum;
}
